import type { Profile } from "@circle-react/types/CommunityBot/Profile";

import { useAvatarConversationPanelStore } from "./useAvatarConversationPanelStore";
import { useIsAvatarsV2Layout } from "./useIsAvatarsV2Layout";

export const useOpenAvatarConversation = () => {
  const openPanel = useAvatarConversationPanelStore(s => s.openPanel);
  const isAvatarsV2Layout = useIsAvatarsV2Layout();

  const canOpenInWidget = (avatar: Profile) =>
    isAvatarsV2Layout && !!avatar.allow_widget_conversations;

  const openInWidget = (avatar: Profile) =>
    openPanel({ avatarId: avatar.id, chatId: null });

  return { canOpenInWidget, openInWidget };
};
